export type SchoolType = 'PRIMARY' | 'HIGH_SCHOOL' | 'PRE_SCHOOL';

export const getGrades = (schoolType: SchoolType = 'PRIMARY'): string[] => {
    switch (schoolType) {
        case 'HIGH_SCHOOL':
            return ['Form 1', 'Form 2', 'Form 3', 'Form 4', 'Form 5', 'Form 6'];
        case 'PRE_SCHOOL':
            return ['Infancy', 'ECD A', 'ECD B'];
        case 'PRIMARY':
        default:
            return ['ECD A', 'ECD B', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7'];
    }
};

export const getGradeInfo = (percentage: number, grade: string = ''): { label: string, description: string, color: string } => {
    const g = grade.toUpperCase();
    
    let info = { label: '', description: '', color: '#E53E3E' };

    // Primary School (Units system for ECDE and Grades 1-7)
    if (g.includes('GRADE') || g.includes('ECD')) {
        if (percentage >= 80) info = { label: '1 Unit', description: 'Excellent', color: '#38A169' };
        else if (percentage >= 70) info = { label: '2 Units', description: 'Very Good', color: '#48BB78' };
        else if (percentage >= 60) info = { label: '3 Units', description: 'Good', color: '#3182CE' };
        else if (percentage >= 50) info = { label: '4 Units', description: 'Satisfactory', color: '#D69E2E' };
        else if (percentage >= 40) info = { label: '5 Units', description: 'Below Average', color: '#DD6B20' };
        else if (percentage >= 35) info = { label: '6 Units', description: 'Fail', color: '#E53E3E' };
        else if (percentage >= 30) info = { label: '7 Units', description: 'Fail', color: '#E53E3E' };
        else if (percentage >= 25) info = { label: '8 Units', description: 'Fail', color: '#E53E3E' };
        else info = { label: '9 Units', description: 'Fail', color: '#E53E3E' };
        return info;
    }

    // Form 5 & 6 (Advanced Secondary)
    if (g.includes('FORM 5') || g.includes('FORM 6')) {
        if (percentage >= 80) return { label: 'A', description: 'Distinction', color: '#38A169' };
        if (percentage >= 70) return { label: 'B', description: 'Merit', color: '#48BB78' };
        if (percentage >= 60) return { label: 'C', description: 'Credit', color: '#3182CE' };
        if (percentage >= 50) return { label: 'D', description: 'Pass', color: '#D69E2E' };
        if (percentage >= 40) return { label: 'E', description: 'Weak Pass', color: '#DD6B20' };
        return { label: 'F', description: 'Fail', color: '#E53E3E' };
    }

    // Form 1 - 4 (Secondary)
    if (g.includes('FORM')) {
        if (percentage >= 75) return { label: 'A', description: 'Distinction', color: '#38A169' };
        if (percentage >= 65) return { label: 'B', description: 'Merit', color: '#48BB78' };
        if (percentage >= 50) return { label: 'C', description: 'Credit', color: '#3182CE' };
        if (percentage >= 40) return { label: 'D', description: 'Pass', color: '#D69E2E' };
        if (percentage >= 35) return { label: 'E', description: 'Weak Pass', color: '#DD6B20' };
        return { label: 'U', description: 'Ungraded', color: '#E53E3E' };
    }

    // Default Fallback
    if (percentage >= 75) return { label: 'A', description: 'Distinction', color: '#38A169' };
    if (percentage >= 65) return { label: 'B', description: 'Merit', color: '#48BB78' };
    if (percentage >= 50) return { label: 'C', description: 'Credit', color: '#3182CE' };
    return { label: 'D', description: 'Pass', color: '#D69E2E' };
};

// Legacy support for simple letter grade calls
export const getLetterGrade = (percentage: number, grade: string = ''): string => {
    return getGradeInfo(percentage, grade).label;
};
